import Button from "../ui/Button";
import classes from "./LogoutPage.module.css";

function LogoutPage({ setUser }) {
  const logoutHandler = () => {
    setUser(null);
  };

  return (
    <div className={classes.logout}>
      <span>You are logging out of the Revellx-Message</span>
      <Button onClick={logoutHandler}>Logout!</Button>
    </div>
  );
}

export default LogoutPage;
